import { render } from "./CopySimple.vue?vue&type=template&id=27e09195"
const script = {}

import exportComponent from "../../../../../../../projects/loyalzilla_admin/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"src/icons/CopySimple.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "27e09195"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('27e09195', __exports__)) {
    api.reload('27e09195', __exports__)
  }
  
  module.hot.accept("./CopySimple.vue?vue&type=template&id=27e09195", () => {
    api.rerender('27e09195', render)
  })

}


export default __exports__